import axios from 'axios';
import { getToken } from './authService';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';

const client = axios.create({ baseURL: API_BASE });
client.interceptors.request.use((cfg) => {
  const token = getToken();
  if (token) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

// Estado del modo crisis: la situación activa (si la hay), las abiertas y el historial.
export async function getCrisis() {
  const { data } = await client.get('/crisis');
  return data;
}

// Una crisis con toda su línea de tiempo.
export async function getCrisisDetalle(id) {
  const { data } = await client.get('/crisis', { params: { id } });
  return data;
}

// Confirmar / contener / resolver / descartar.
export async function cambiarEstadoCrisis(id, estado, detalle) {
  const { data } = await client.patch('/crisis', { estado, detalle }, { params: { id } });
  return data;
}

// Abrir una crisis a mano, cuando el equipo la ve antes que el radar.
export async function abrirCrisis(payload) {
  const { data } = await client.post('/crisis', payload);
  return data;
}

// --- Sala de Situación (panel completo de una crisis) ---
export async function getPanelCrisis(id) {
  const { data } = await client.get(`/crisis/${id}/panel`);
  return data;
}

// Humor social: análisis de los comentarios de las publicaciones del tema.
export async function getHumorSocial(id) {
  const { data } = await client.get(`/crisis/${id}/social`);
  return data;
}

// Asistente conversacional de la crisis: conoce todo el panel y responde.
export async function chatCrisis(id, mensaje, history) {
  const { data } = await client.post(`/crisis/${id}/chat`, { mensaje, history },
    { timeout: 120000 });
  return data;
}

// Actualiza los datos de la crisis a pedido (busca prensa nueva, escala, re-evalúa).
export async function refrescarCrisis(id) {
  const { data } = await client.post(`/crisis/${id}/refresh`, {}, { timeout: 120000 });
  return data;
}

export async function crearAccion(crisisId, payload) {
  const { data } = await client.post(`/crisis/${crisisId}/actions`, payload);
  return data;
}

export async function actualizarAccion(crisisId, accionId, cambios) {
  const { data } = await client.patch(`/crisis/${crisisId}/actions`, cambios, {
    params: { accion: accionId },
  });
  return data;
}

// Consultarle a la IA sobre una acción puntual (pedir el borrador, cómo se hace…).
export async function chatAccion(crisisId, accionId, mensaje) {
  const { data } = await client.post(`/crisis/${crisisId}/action-chat`, {
    accion_id: accionId, mensaje,
  }, { timeout: 120000 });
  return data;
}

// Paso a paso de una acción (lo arma la IA, se cachea; regenerar lo rehace).
export async function getPlanAccion(crisisId, accionId, regenerar = false) {
  const { data } = await client.post(`/crisis/${crisisId}/action-plan`, {
    accion_id: accionId, regenerar,
  }, { timeout: 120000 });
  return data;
}

// Busca en la web los teléfonos/emails de los contactos que no los tienen.
export async function buscarContactos(crisisId, accionId) {
  const { data } = await client.post(`/crisis/${crisisId}/find-contacts`,
    { accion_id: accionId }, { timeout: 120000 });
  return data;
}

// Contactos reales de una acción (los carga el equipo, no la IA).
export async function crearContacto(crisisId, accionId, contacto) {
  const { data } = await client.post(`/crisis/${crisisId}/action-contacts`, contacto,
    { params: { accion: accionId } });
  return data;
}

export async function actualizarContacto(crisisId, accionId, contactoId, cambios) {
  const { data } = await client.patch(`/crisis/${crisisId}/action-contacts`,
    { contacto_id: contactoId, ...cambios }, { params: { accion: accionId } });
  return data;
}

export async function borrarContacto(crisisId, accionId, contactoId) {
  const { data } = await client.delete(`/crisis/${crisisId}/action-contacts`,
    { params: { accion: accionId, contacto: contactoId } });
  return data;
}

export async function borrarAccion(crisisId, accionId) {
  const { data } = await client.delete(`/crisis/${crisisId}/actions`, {
    params: { accion: accionId },
  });
  return data;
}

// --- Temas vigilados ---
export async function getTemasVigilados() {
  const { data } = await client.get('/crisis/watch');
  return data;
}

export async function crearTemaVigilado(payload) {
  const { data } = await client.post('/crisis/watch', payload);
  return data;
}

export async function actualizarTemaVigilado(id, cambios) {
  const { data } = await client.patch('/crisis/watch', cambios, { params: { id } });
  return data;
}

export async function borrarTemaVigilado(id) {
  const { data } = await client.delete('/crisis/watch', { params: { id } });
  return data;
}

const crisisService = {
  getCrisis, getCrisisDetalle, cambiarEstadoCrisis, abrirCrisis,
  getPanelCrisis, getHumorSocial, chatCrisis, refrescarCrisis, crearAccion, actualizarAccion, borrarAccion, chatAccion,
  getPlanAccion, buscarContactos, crearContacto, actualizarContacto, borrarContacto,
  getTemasVigilados, crearTemaVigilado, actualizarTemaVigilado, borrarTemaVigilado,
};
export default crisisService;
